import { Route, Routes } from "react-router-dom";
import { PTLI1201001Q } from "@/tra/tancis/ptli/btch/info/PTLI1201001Q";
import { PTLI1201002S } from "@/tra/tancis/ptli/btch/info/PTLI1201002S";
import { PTLI1201003S } from "@/tra/tancis/ptli/btch/info/PTLI1201003S";
import { PTLI1201004Q } from "@/tra/tancis/ptli/btch/info/PTLI1201004Q";
import { PTLI1202001Q } from "@/tra/tancis/ptli/btch/schd/PTLI1202001Q";
import { PTLI1202002S } from "@/tra/tancis/ptli/btch/schd/PTLI1202002S";
import { PTLI1202003S } from "@/tra/tancis/ptli/btch/schd/PTLI1202003S";
import { PTLI1202004Q } from "@/tra/tancis/ptli/btch/schd/PTLI1202004Q";
import { PTLI1203001Q } from "@/tra/tancis/ptli/btch/excutn/PTLI1203001Q";
import { PTLI1203002S } from "@/tra/tancis/ptli/btch/excutn/PTLI1203002S";
import { PTLI1204001Q } from "@/tra/tancis/ptli/btch/excutnrslt/PTLI1204001Q";
import { PTLI1204002Q } from "@/tra/tancis/ptli/btch/excutnrslt/PTLI1204002Q";

/*
 * 응용기능별 Router
 * - 명명규칙 : 응용기능 2 레벨 메타 단어(용어) 카멜표기(첫글자 대문자) + Router
 * - 응용기능 2 레벨 별로 Router 분리 원칙(기본)
 * - 응용기능 레벨별로 소문자로 구분하여 경로 작성
 * - 최종 라우팅하는 주소는 화면 아이디에서 '-' 구분자를 빼고 소문자로 변환하여 작성
 * - element 에 해당 화면 컴포넌트 기입
 * - 화면에서 파라메터로 받아서 사용할 키값은 path 문자열에 ':변수명' 으로 기입하여 해당 컴포넌트 인지하여 사용
 * TODO URL의 'key' 를 실제 ID로 변경 하세요.
 * TODO 위의 한글 주석은 마지막에 전부 삭제하세요.
 */

export const BtchRouter = () => {
    return (
        <Routes>
            {/** ==================== 배치정보관리 ==================== */}
            <Route path="/info/ptli1201001q" element={<PTLI1201001Q />} />
            <Route path="/info/ptli1201002s" element={<PTLI1201002S />} />
            <Route path="/info/ptli1201003s/:btchId" element={<PTLI1201003S />} />
            <Route path="/info/ptli1201004q/:btchId" element={<PTLI1201004Q />} />
            {/** ==================== 스케줄관리 ==================== */}
            <Route path="/schd/ptli1202001q" element={<PTLI1202001Q />} />
            <Route path="/schd/ptli1202002s" element={<PTLI1202002S />} />
            <Route path="/schd/ptli1202003s/:btchSchdId" element={<PTLI1202003S />} />
            <Route path="/schd/ptli1202004q/:btchSchdId" element={<PTLI1202004Q />} />
            {/** ==================== 배치실행관리 ==================== */}
            <Route path="/excutn/ptli1203001q" element={<PTLI1203001Q />} />
            <Route path="/excutn/ptli1203002s/:btchId" element={<PTLI1203002S />} />
            {/** ==================== 배치실행결과 ==================== */}
            <Route path="/excutnrslt/ptli1204001q" element={<PTLI1204001Q />} />
            <Route path="/excutnrslt/ptli1204002q/:jobExecutionId" element={<PTLI1204002Q />} />
        </Routes>
    );
};
